import { computed, Injectable, Signal, signal } from '@angular/core';
import { AlertProject } from '../../../sdk/sdk';

@Injectable({ providedIn: 'root' })
export class AlertPopoverService {
  private readonly _projectsByType = signal<Map<string, AlertProject[]>>(new Map());

  setProjectsForType(type: string, projects: AlertProject[]): void {
    this._projectsByType.update(map => {
      const next = new Map(map);
      next.set(type, projects);
      return next;
    });
  }

  projectsForType(type: string): Signal<AlertProject[]> {
    return computed(() => this._projectsByType().get(type) ?? []);
  }

  clear(): void {
    this._projectsByType.set(new Map());
  }
}
